import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { LoginResponseDataSchema, InviteEmployeeSchema } from "schema"
import { z } from "zod"

export const useInviteEmployeeMutation = () => {
  return useMutation({
    mutationFn: async (inviteData: z.infer<typeof InviteEmployeeSchema>) => {
      const { data } = await axios.post("/employees/invite", inviteData)
      return data.data as z.infer<typeof LoginResponseDataSchema>
    },
  })
}
